"use client"
import { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import { useDispatch } from "react-redux";
import { useRouter } from "next/navigation";
import { Logout } from "@/GlobalRedux/Slices/UserSlice";
import { RiHome2Line } from "react-icons/ri";
import { AiOutlineProduct, AiTwotoneHome } from "react-icons/ai";
import { BiLogOutCircle } from "react-icons/bi";
import { PiGreaterThanBold } from "react-icons/pi";
import { SiLootcrate } from "react-icons/si";
import { HiViewGridAdd } from "react-icons/hi";
import { DiGhostSmall } from "react-icons/di";
import { MdOutlineLibraryAdd } from "react-icons/md";
import { TbBrandAirtable, TbCategory2 } from "react-icons/tb";

const menuItems = [
  { name: "Dashboard", path: "/admin", icon: <RiHome2Line size={20} /> },
  { name: "Add Products", path: "/addProduct", icon: <AiOutlineProduct size={20} /> },
  { name: "Add Category", path: "/addCategory", icon: <SiLootcrate size={20} /> },
  { name: "Add Brand", path: "/addBrand", icon: <MdOutlineLibraryAdd size={20} /> },
  { name: "Add Banner", path: "/addBanner", icon: <MdOutlineLibraryAdd size={20} /> },
  { name: "All Products", path: "/allProducts", icon: <DiGhostSmall size={20} /> },
  { name: "All Brands", path: "/allbrands", icon: <TbBrandAirtable size={20} /> },
  { name: "All Category", path: "/allcategory", icon: <TbCategory2 size={20} /> },
  { name: "All Banners", path: "/allbanners", icon: <TbCategory2 size={20} /> },
  { name: "View Orders", path: "/orders", icon: <HiViewGridAdd size={20} /> },
  { name: "Home Page", path: "/", icon: <AiTwotoneHome size={20} /> },
];

export function Sidebar() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const dispatch = useDispatch();
  const router = useRouter();

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <>
      <nav id="sidebar" className="lg:min-w-[250px] w-max">
        <div
          id="sidebar-collapse-menu"
          className={`bg-forestFog shadow-lg h-screen fixed top-0 left-0 z-[100] overflow-auto transition-all duration-500
          ${isSidebarOpen ? "w-[250px]" : "w-0"} lg:w-[250px]`}
        >
          <div className="pt-8 pb-2 px-6 sticky top-0 z-9999 bg-forestFog">
            <Link href="/admin">
              <Image height={800} width={700} src="/Images/new_logo.png" alt="Logo" className="h-28 w-full object-contain" />
            </Link>
          </div>
          <div className="py-6 px-6">
            <ul className="space-y-2">
              {menuItems.map(({ name, path, icon }) => (
                <li
                  key={name}
                  onClick={() => {
                    router.push(path);
                    setIsSidebarOpen(false);
                  }}
                  className="menu-item text-forestFog text-sm flex items-center cursor-pointer hover:border-2 border-vanillaWhite bg-vanillaWhite hover:bg-forestFog hover:text-vanillaWhite rounded-md px-3 py-3 transition-all duration-300 gap-4"
                >
                  {icon}
                  <span className="text-md font-bold">{name}</span>
                </li>
              ))}
              <li
                onClick={async () => {
                  await dispatch(Logout());
                  router.push("/");
                }}
                className="menu-item text-forestFog text-sm flex items-center cursor-pointer hover:border-2 border-vanillaWhite bg-vanillaWhite hover:bg-forestFog hover:text-vanillaWhite rounded-md px-3 py-3 transition-all duration-300 gap-4"
              >
                <BiLogOutCircle size={20} />
                <span className="text-md font-bold">Logout</span>
              </li>
            </ul>
          </div>
        </div>
        {isSidebarOpen && <div onClick={toggleSidebar} className="fixed inset-0 bg-black bg-opacity-50 z-[98] lg:hidden" />}
      </nav>
      <button
        id="toggle-sidebar"
        onClick={toggleSidebar}
        className={isSidebarOpen ? "hidden" : "lg:hidden w-8 h-8 z-[100] fixed top-[36px] left-[10px] cursor-pointer bg-[#007bff] flex items-center justify-center rounded-full outline-none transition-all duration-500"}
      >
        <PiGreaterThanBold color="#fff" />
      </button>
    </>
  );
}
